
export default function HorizontalSeparator() {
    return (<div style={{position: "relative", top: "50%", borderTop: "2px solid", height: "100%"}}/>)
}